import { atom, selector } from 'recoil';
import { SmsReceptions } from '@/sdk/data-contracts';

export const smsListRecoil = atom<SmsReceptions[]>({
  key: 'smsListRecoil',
  default: [],
});

// export const eventDetailRecoil = atom<GetDetailSiteDtoRx | null>({
//   key: 'eventDetailRecoil',
//   default: null,
// });

// export const eventDetailIdRecoil = atom<number | null>({
//   key: 'eventDetailIdRecoil',
//   default: null,
// });
